__turbopack_context__.v({
  "className": "japanesenamefont_c9bdf71e-module__j0PXOq__className",
});
